import { ADD_BATCH, FETCH_PAGINATED_BATCHES, FETCH_ALL_BATCHES, BATCH_QUERY } from '../../mutation-types';

export default {
  [FETCH_PAGINATED_BATCHES](state, { batches, pagination }) {
    state.items = batches;
    state.pagination = pagination;
  },

  [FETCH_ALL_BATCHES](state, batch) {
    state.all = batch;
  },

  [ADD_BATCH](state, batch) {
    state.all.push(batch);
  },

  [BATCH_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/batch/mutations.js